import React from 'react';

/**
 * Content for the types of medical records page
 * (supporting-evidence/medical-records-types).
 */
export const medicalRecordTypesQuestion = {
  title:
    'What types of medical records would you like us to review on your behalf?',
  labels: {
    vaOrMilitary: 'VA or military medical records',
    privateProvider: 'Medical records from other healthcare providers',
  },
  requiredError: 'Select at least one type of medical record',
};

export const MedicalRecordTypesDescription = () => (
  <>
    <p>
      <strong>Note:</strong> We can locate, access, and review medical records
      from VA health facilities right away when you submit your claim. But we’ll
      need your permission to request access to your records from other
      healthcare facilities on your behalf.
    </p>
    <h4>
      The difference between VA records and records from other medical providers
    </h4>
    <va-accordion bordered data-testid="medical-record-types-accordion">
      <va-accordion-item
        header="Records we can get and review from VA or military healthcare providers"
        level="5"
        open
        bordered
      >
        <p className="vads-u-margin-top--0">
          We can locate, access, and review records from these healthcare
          providers:
        </p>
        <ul>
          <li>VA medical centers or clinics</li>
          <li>TRICARE healthcare program</li>
          <li>Community-Based Outpatient Clinics</li>
          <li>DOD military treatment facilities</li>
        </ul>
      </va-accordion-item>
      <va-accordion-item
        header="Records we can review from other healthcare providers"
        level="5"
        open
        bordered
      >
        <p className="vads-u-margin-top--0">
          We’ll need your permission to request access to your records on your
          behalf from these other healthcare providers:
        </p>
        <ul>
          <li>Private healthcare providers (non-VA)</li>
          <li>Veteran’s Choice</li>
          <li>Vet Centers</li>
          <li>Community care providers</li>
        </ul>
      </va-accordion-item>
    </va-accordion>
  </>
);
